import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Paper,
  Avatar,
  Breadcrumbs,
  Link as MuiLink,
  Fade,
  Slide,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Divider
} from '@mui/material';
import {
  NavigateNext as NavigateNextIcon,
  Gavel as GavelIcon,
  Security as SecurityIcon,
  VerifiedUser as VerifiedUserIcon,
  Payment as PaymentIcon,
  LocalShipping as LocalShippingIcon,
  Store as StoreIcon,
  ShoppingCart as ShoppingCartIcon,
  Support as SupportIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Warning as WarningIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MarketplacePolicy = () => {
  const policyCategories = [
    {
      icon: <StoreIcon />,
      title: 'বিক্রেতা নীতিমালা',
      description: 'বিক্রেতাদের জন্য নিয়ম ও শর্তাবলী',
      color: '#4CAF50'
    },
    {
      icon: <ShoppingCartIcon />,
      title: 'ক্রেতা নীতিমালা',
      description: 'ক্রেতাদের জন্য নিয়ম ও শর্তাবলী',
      color: '#2196F3'
    },
    {
      icon: <PaymentIcon />,
      title: 'পেমেন্ট নীতিমালা',
      description: 'লেনদেন ও পেমেন্ট সংক্রান্ত নীতি',
      color: '#FF9800'
    },
    {
      icon: <LocalShippingIcon />,
      title: 'ডেলিভারি নীতিমালা',
      description: 'পণ্য সরবরাহ ও ডেলিভারি নীতি',
      color: '#9C27B0'
    },
    {
      icon: <SecurityIcon />,
      title: 'নিরাপত্তা নীতিমালা',
      description: 'ডেটা ও তথ্য নিরাপত্তা নীতি',
      color: '#F44336'
    },
    {
      icon: <SupportIcon />,
      title: 'বিরোধ নিষ্পত্তি',
      description: 'সমস্যা সমাধান ও বিরোধ নিষ্পত্তি',
      color: '#607D8B'
    }
  ];

  const sellerPolicies = [
    {
      title: 'পণ্য তালিকাভুক্তকরণ',
      items: [
        'সঠিক ও সত্য তথ্য প্রদান করতে হবে',
        'উন্নত মানের পণ্যের ছবি আপলোড করতে হবে',
        'পণ্যের বিস্তারিত বিবরণ দিতে হবে',
        'প্রতারণামূলক তথ্য প্রদান নিষিদ্ধ'
      ]
    },
    {
      title: 'মূল্য নির্ধারণ',
      items: [
        'প্রতিযোগিতামূলক মূল্য নির্ধারণ',
        'হঠাৎ মূল্য বৃদ্ধি নিষিদ্ধ',
        'বিশেষ ছাড় ও অফার সঠিকভাবে উল্লেখ',
        'লুকানো খরচ নিষিদ্ধ'
      ]
    },
    {
      title: 'অর্ডার পরিচালনা',
      items: [
        '২৪ ঘন্টার মধ্যে অর্ডার নিশ্চিত করতে হবে',
        'নির্ধারিত সময়ে পণ্য প্রস্তুত রাখতে হবে',
        'স্টক শেষ হলে তাৎক্ষণিক জানাতে হবে',
        'গ্রাহকের সাথে নিয়মিত যোগাযোগ রাখতে হবে'
      ]
    }
  ];

  const buyerPolicies = [
    {
      title: 'অর্ডার প্রক্রিয়া',
      items: [
        'সঠিক ঠিকানা ও যোগাযোগের তথ্য প্রদান',
        'অর্ডার নিশ্চিতকরণের পর বাতিল নিষিদ্ধ',
        'পেমেন্ট সম্পূর্ণ করার পর অর্ডার চূড়ান্ত',
        'ভুল তথ্যের জন্য ক্রেতা দায়ী'
      ]
    },
    {
      title: 'পেমেন্ট নিয়ম',
      items: [
        'অর্ডারের সময় সম্পূর্ণ পেমেন্ট',
        'নিরাপদ পেমেন্ট গেটওয়ে ব্যবহার',
        'রিফান্ড ৭-১৪ কার্যদিবসে',
        'পেমেন্ট বিরোধে প্রমাণ প্রয়োজন'
      ]
    },
    {
      title: 'রিটার্ন ও রিফান্ড',
      items: [
        'ডেলিভারির ৭ দিনের মধ্যে রিটার্ন',
        'পণ্যের মূল অবস্থায় রিটার্ন করতে হবে',
        'ক্ষতিগ্রস্ত পণ্যের জন্য তাৎক্ষণিক রিপোর্ট',
        'রিটার্ন শিপিং খরচ ক্রেতা বহন করবেন'
      ]
    }
  ];

  const prohibitedItems = [
    'অবৈধ ও নিষিদ্ধ পণ্য',
    'নকল ও ভেজাল পণ্য',
    'মেয়াদোত্তীর্ণ খাদ্যপণ্য',
    'অস্ত্র ও বিস্ফোরক',
    'মাদকদ্রব্য ও তামাক',
    'প্রাণী ও পশুপাখি',
    'চুরি বা হারানো পণ্য',
    'কপিরাইট লঙ্ঘনকারী পণ্য'
  ];

  const penaltyActions = [
    {
      violation: 'প্রথম লঙ্ঘন',
      action: 'সতর্কতা ও নির্দেশনা',
      icon: <WarningIcon sx={{ color: '#FF9800' }} />
    },
    {
      violation: 'দ্বিতীয় লঙ্ঘন',
      action: '৭ দিনের জন্য অ্যাকাউন্ট স্থগিত',
      icon: <CancelIcon sx={{ color: '#F44336' }} />
    },
    {
      violation: 'তৃতীয় লঙ্ঘন',
      action: '৩০ দিনের জন্য অ্যাকাউন্ট স্থগিত',
      icon: <CancelIcon sx={{ color: '#F44336' }} />
    },
    {
      violation: 'গুরুতর লঙ্ঘন',
      action: 'স্থায়ী অ্যাকাউন্ট বন্ধ',
      icon: <CancelIcon sx={{ color: '#D32F2F' }} />
    }
  ];

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
        {/* Hero Section */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            py: 8,
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          <Container>
            <Breadcrumbs 
              separator={<NavigateNextIcon fontSize="small" />} 
              aria-label="breadcrumb"
              sx={{ mb: 4, '& .MuiBreadcrumbs-separator': { color: 'rgba(255,255,255,0.7)' } }}
            >
              <MuiLink component={Link} to="/" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                হোম
              </MuiLink>
              <Typography sx={{ color: 'white' }}>মার্কেটপ্লেস নীতিমালা</Typography>
            </Breadcrumbs>

            <Fade in timeout={1000}>
              <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                  মার্কেটপ্লেস নীতিমালা
                </Typography>
                <Typography variant="h5" sx={{ opacity: 0.9, maxWidth: '800px', mx: 'auto' }}>
                  গ্রামীণ বাজারের নিয়ম-কানুন ও শর্তাবলী যা সকল ব্যবহারকারীর জন্য প্রযোজ্য
                </Typography>
              </Box>
            </Fade>
          </Container>
        </Box>

        <Container sx={{ py: 6 }}>
          {/* Policy Categories */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              নীতিমালার বিভাগসমূহ
            </Typography>
            <Grid container spacing={6} sx={{ px: 2 }}>
              {policyCategories.map((category, index) => (
                <Grid item xs={12} sm={6} md={4} key={index} sx={{ mb: 4 }}>
                  <Slide direction="up" in timeout={800 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 4,
                        height: '100%',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                        },
                        border: '1px solid #e2e8f0',
                        borderRadius: 2,
                        mx: 1,
                        mt: 2
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: category.color,
                          width: 72,
                          height: 72,
                          mx: 'auto',
                          mb: 3
                        }}
                      >
                        {category.icon}
                      </Avatar>
                      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
                        {category.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, fontSize: '1rem' }}>
                        {category.description}
                      </Typography>
                    </Card>
                  </Slide>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Seller Policies */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              বিক্রেতা নীতিমালা
            </Typography>
            <Grid container spacing={4}>
              {sellerPolicies.map((policy, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Fade in timeout={1000 + index * 200}>
                    <Card sx={{ height: '100%', border: '1px solid #e2e8f0' }}>
                      <CardContent sx={{ p: 4 }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#4CAF50', mb: 3 }}>
                          {policy.title}
                        </Typography>
                        <List>
                          {policy.items.map((item, itemIndex) => (
                            <ListItem key={itemIndex} sx={{ px: 0, py: 1 }}>
                              <ListItemIcon sx={{ minWidth: 36 }}>
                                <CheckCircleIcon color="primary" fontSize="small" />
                              </ListItemIcon>
                              <ListItemText 
                                primary={item} 
                                sx={{ 
                                  '& .MuiListItemText-primary': { 
                                    fontSize: '0.95rem',
                                    lineHeight: 1.6
                                  } 
                                }} 
                              />
                            </ListItem>
                          ))}
                        </List>
                      </CardContent>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Buyer Policies */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              ক্রেতা নীতিমালা
            </Typography>
            <Grid container spacing={4}>
              {buyerPolicies.map((policy, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Fade in timeout={1000 + index * 200}>
                    <Card sx={{ height: '100%', border: '1px solid #e2e8f0' }}>
                      <CardContent sx={{ p: 4 }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#2196F3', mb: 3 }}>
                          {policy.title}
                        </Typography>
                        <List>
                          {policy.items.map((item, itemIndex) => (
                            <ListItem key={itemIndex} sx={{ px: 0, py: 1 }}>
                              <ListItemIcon sx={{ minWidth: 36 }}>
                                <CheckCircleIcon color="primary" fontSize="small" />
                              </ListItemIcon>
                              <ListItemText 
                                primary={item} 
                                sx={{ 
                                  '& .MuiListItemText-primary': { 
                                    fontSize: '0.95rem',
                                    lineHeight: 1.6
                                  } 
                                }} 
                              />
                            </ListItem>
                          ))}
                        </List>
                      </CardContent>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Prohibited Items */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              নিষিদ্ধ পণ্যসমূহ
            </Typography>
            <Paper sx={{ p: 4, border: '1px solid #e2e8f0' }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3, color: '#F44336' }}>
                নিম্নলিখিত পণ্যসমূহ বিক্রয় সম্পূর্ণ নিষিদ্ধ:
              </Typography>
              <Grid container spacing={2}>
                {prohibitedItems.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Chip
                      label={item}
                      variant="outlined"
                      color="error"
                      sx={{ 
                        width: '100%', 
                        height: 'auto',
                        py: 1,
                        '& .MuiChip-label': {
                          whiteSpace: 'normal',
                          textAlign: 'center'
                        }
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Box>

          {/* Penalty Actions */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              লঙ্ঘনের শাস্তি
            </Typography>
            <Grid container spacing={4}>
              {penaltyActions.map((penalty, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Fade in timeout={1200 + index * 200}>
                    <Card
                      sx={{
                        textAlign: 'center',
                        p: 3,
                        height: '100%',
                        border: '1px solid #e2e8f0',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }
                      }}
                    >
                      <Box sx={{ mb: 2 }}>
                        {penalty.icon}
                      </Box>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        {penalty.violation}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {penalty.action}
                      </Typography>
                    </Card>
                  </Fade>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Terms and Conditions */}
          <Box sx={{ mb: 8, pt: '80px' }}>
            <Typography variant="h3" component="h2" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 6 }}>
              সাধারণ শর্তাবলী
            </Typography>
            <Paper sx={{ p: 4, border: '1px solid #e2e8f0' }}>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    ব্যবহারের শর্তাবলী
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    গ্রামীণ বাজার ব্যবহার করার মাধ্যমে আপনি আমাদের সকল নিয়ম-কানুন মেনে চলতে সম্মত হচ্ছেন। 
                    আমাদের প্ল্যাটফর্মে যেকোনো ধরনের অবৈধ কার্যকলাপ সম্পূর্ণ নিষিদ্ধ।
                  </Typography>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    আমরা যেকোনো সময় আমাদের নীতিমালা পরিবর্তন করার অধিকার রাখি। 
                    পরিবর্তনের ক্ষেত্রে সকল ব্যবহারকারীকে আগাম জানানো হবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    দায়বদ্ধতা ও দায়মুক্তি
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    গ্রামীণ বাজার একটি মধ্যস্থতাকারী প্ল্যাটফর্ম। আমরা পণ্যের গুণগত মান বা বিক্রেতার 
                    সেবার জন্য সরাসরি দায়ী নই। তবে আমরা সর্বোচ্চ চেষ্টা করি সেরা সেবা নিশ্চিত করতে।
                  </Typography>
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    যেকোনো বিরোধের ক্ষেত্রে আমাদের গ্রাহক সেবা টিম সমাধানে সহায়তা করবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    গোপনীয়তা ও তথ্য সুরক্ষা
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                    আমরা আপনার ব্যক্তিগত তথ্যের সর্বোচ্চ নিরাপত্তা নিশ্চিত করি। 
                    আপনার অনুমতি ছাড়া কোনো তথ্য তৃতীয় পক্ষের সাথে শেয়ার করা হয় না।
                  </Typography>
                  <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                    আমাদের প্রাইভেসি পলিসি বিস্তারিত জানতে সংশ্লিষ্ট পেজ দেখুন।
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Paper>
          </Box>

          {/* Contact for Policy */}
          <Paper
            sx={{
              p: 6,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              borderRadius: 3,
              mt: '80px'
            }}
          >
            <InfoIcon sx={{ fontSize: 64, mb: 2, opacity: 0.9 }} />
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
              নীতিমালা সংক্রান্ত প্রশ্ন?
            </Typography>
            <Typography variant="h6" sx={{ mb: 4, opacity: 0.9, maxWidth: '600px', mx: 'auto' }}>
              আমাদের নীতিমালা সম্পর্কে কোনো প্রশ্ন থাকলে আমাদের সাথে যোগাযোগ করুন
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <MuiLink
                component={Link}
                to="/contact"
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'grey.100'
                  }
                }}
              >
                যোগাযোগ করুন
              </MuiLink>
              <MuiLink
                component={Link}
                to="/help"
                sx={{
                  border: '2px solid white',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textDecoration: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                সাহায্য কেন্দ্র
              </MuiLink>
            </Box>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default MarketplacePolicy; 